export default {
  en: {
    title: 'Food',
    titleByRole: {
      client: 'Deliverly - delivery',
      courier: 'Deliverly - courier',
      restaurant: 'Deliverly - restaurant',
      admin: 'Deliverly - admin',
    },
    tagline: 'Food delivery',
  },
  ru: {
    title: 'Еда',
    titleByRole: {
      client: 'Deliverly - доставка еды',
      courier: 'Deliverly - курьер',
      restaurant: 'Deliverly - ресторан',
      admin: 'Deliverly - админ',
    },
    tagline: 'Доставка еды',
  },
}
